import * as ActionCable from '@rails/actioncable'

ActionCable.logger.enabled = true

import consumer from "./consumer"

consumer.subscriptions.create("SignatureChannel", {
  connected() {
    // Called when the subscription is ready for use on the server
    console.log("signature channel connected")
  },

  disconnected() {
    // Called when the subscription has been terminated by the server
    console.log("signature channel disconnected")
  },

  received(data) {
    // defined for every page in general/index.js
    if(data.action === 'cancelled') {
      // the signer read the brief and pressed "Nekaj ni v redu"
      onSignatureCancelled(data);
    } else {
      onSignatureSigned(data.uuid, data.payload);
    }
  }
});
